import { n2api } from "./n2api";

export const useApiAuth = () => {
  const apiLogin = (email, password) => {
    return n2api
      .post(
        `/auth/login`,
        {
          email: email,
          password: password,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getCsrfToken = () => {
    return n2api
      .get(
        `/sanctum/csrf-cookie`,

        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      )
      .then((response) => {
        return response.success;
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return { apiLogin, getCsrfToken };
};